// Title Manager for React 19
// Provides a clean API for managing page titles and meta tags

class TitleManager {
  constructor() {
    this.defaultTitle = 'ITORA - AI Avatar Generation';
    this.defaultDescription = 'Create stunning AI-generated avatars with our advanced technology';
    this.baseTitle = 'ITORA';
  }

  // Set page title with optional suffix
  setTitle(title, suffix = true) {
    const fullTitle = suffix ? `${this.baseTitle} - ${title}` : title;
    document.title = fullTitle;
    return fullTitle;
  }

  // Set meta description
  setDescription(description) {
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.name = 'description';
      document.head.appendChild(metaDescription);
    }
    metaDescription.content = description;
    return description;
  }

  // Set Open Graph tags
  setOpenGraph({ title, description, image, url }) {
    this.setOGTag('og:title', title);
    this.setOGTag('og:description', description);
    if (image) this.setOGTag('og:image', image);
    if (url) this.setOGTag('og:url', url);
  }

  // Set Twitter Card tags
  setTwitterCard({ title, description, image, cardType = 'summary_large_image' }) {
    this.setTwitterTag('twitter:card', cardType);
    this.setTwitterTag('twitter:title', title);
    this.setTwitterTag('twitter:description', description);
    if (image) this.setTwitterTag('twitter:image', image);
  }

  // Helper method to set Open Graph tags
  setOGTag(property, content) {
    let tag = document.querySelector(`meta[property="${property}"]`);
    if (!tag) {
      tag = document.createElement('meta');
      tag.setAttribute('property', property);
      document.head.appendChild(tag);
    }
    tag.content = content;
  }

  // Helper method to set Twitter tags
  setTwitterTag(name, content) {
    let tag = document.querySelector(`meta[name="${name}"]`);
    if (!tag) {
      tag = document.createElement('meta');
      tag.name = name;
      document.head.appendChild(tag);
    }
    tag.content = content;
  }

  // Reset to default title and description
  reset() {
    this.setTitle(this.defaultTitle);
    this.setDescription(this.defaultDescription);
  }

  // Set canonical URL
  setCanonical(url) {
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.rel = 'canonical';
      document.head.appendChild(canonical);
    }
    canonical.href = url;
  }
}

// Create singleton instance
const titleManager = new TitleManager();

export default titleManager; 